export const formForMatchMakingFields = [
    {
        label: 'Company Name*',
        type: 'text',
        desc: '',
        name: 'company',
        placeholder: 'Enter Company Name',
        disabled: false,
        componentType: 'input',
        errorText: 'Company Name'
    },
    {
        label: 'Customer Name*',
        type: 'text',
        name: 'customerName',
        placeholder: 'Enter Customer Name',
        disabled: false,
        componentType: 'input',
        errorText: 'Customer Name'
    },
    {
        label: 'Customer Industry*',
        type: 'text',
        name: 'customerIndustry',
        placeholder: 'Enter Customer Industry',
        disabled: false,
        componentType: 'input',
        errorText: 'Customer Industry'
    },
    {
        label: 'Phone*',
        type: 'text',
        componentType: 'input',
        name: 'mobileNumber',
        placeholder: 'Enter Phone',
        disabled: false,
        errorText: 'Phone'
    },
    {
        label: 'Email*',
        type: 'text',
        componentType: 'input',
        name: 'emailAddress',
        placeholder: 'Enter Email',
        disabled: false,
        errorText: 'Email'
    },
    {
        label: 'Membership Number*',
        type: 'text',
        name: 'membershipNo',
        placeholder: 'Enter Membership Number',
        disabled: true,
        componentType: 'input',
        errorText: 'Membership Number'
    },
    {
        label: 'Country*',
        type: 'select',
        name: 'country',
        placeholder: 'Select Country',
        disabled: false,
        componentType: 'input',
        errorText: 'Country'
    },
    {
        label: 'City*',
        type: 'select',
        name: 'city',
        placeholder: 'Select City',
        disabled: false,
        componentType: 'input',
        errorText: 'City'
    },
    {
        label: 'Description*',
        type: 'textarea',
        name: 'description',
        placeholder: 'Enter Description',
        disabled: false,
        componentType: 'input',
        errorText: 'Description'
    }
];
